<div class="metrics-toolbar" *ngIf="showEmptyAssignment">
  <p class="empty-assignment">
    No clients assigned to you as primary manager.
  </p>
</div>

<div *ngIf="loading" class="flex items-center justify-center py-16">
  <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
</div>

<ng-container *ngIf="!loading && metrics">

  <div class="metrics-grid">
    <article class="metric-tile">
      <div class="metric-value">{{ formatCount(metrics.associatedClients.current) }}</div>
      <div class="metric-label">{{ associatedClientsLabel }}</div>
      <div class="metric-trend" [ngClass]="trendTone(metrics.associatedClients)">
        {{ associatedClientsTrend }}
      </div>
    </article>

    <article class="metric-tile">
      <div class="metric-value">{{ formatCount(metrics.activeMembers.current) }}</div>
      <div class="metric-label">Active Members</div>
      <div class="metric-trend" [ngClass]="trendTone(metrics.activeMembers)">
        {{ activeMembersTrend }}
      </div>
    </article>

    <article class="metric-tile">
      <div class="metric-value">{{ formatCount(metrics.enrollmentsAwaitingAcknowledgement.current) }}</div>
      <div class="metric-label">Awaiting Acknowledgement</div>
      <div class="metric-trend tone-neutral">
        {{ awaitingTrend }}
      </div>
    </article>

    <article class="metric-tile">
      <div class="metric-value">{{ formatCount(metrics.upcomingOpenEnrollment?.next30Days) }}</div>
      <div class="metric-label">OE in Next 30 Days</div>
      <div class="metric-trend tone-neutral">{{ upcomingOpenEnrollmentTrend }}</div>
    </article>
  </div>
</ng-container>
